import React from "react";
import i18next from "i18next";

const { relationLabels, clientsLabels, optionsLabels } = {
  relationLabels: i18next.t("providers.termExtension.typeRelations", {
    returnObjects: true,
  }),
  clientsLabels: i18next.t("providers.termExtension.clients", {
    returnObjects: true,
  }),
  optionsLabels: i18next.t("providers.termExtension.options", {
    returnObjects: true,
  }),
};

const options = [
  { label: i18next.t("yes"), value: true },
  { label: i18next.t("no"), value: false },
];

const typeRelations = [
  { label: relationLabels.globalDiscount, value: "globalDiscount" },
  { label: relationLabels.discount, value: "discount" },
  { label: relationLabels.directPayment, value: "directPayment" },
];

const clients = [
  {
    label: (
      <strong>
        {i18next.t("providers.termExtension.clients.clientLabel")}
      </strong>
    ),
    value: "client",
    description: (
      <p className="p-fix" style={{ marginLeft: "3.5rem", marginTop: "-2rem" }}>
        {clientsLabels.client}
      </p>
    ),
  },
  {
    label: (
      <strong>
        {i18next.t("providers.termExtension.clients.providerLabel")}
      </strong>
    ),
    value: "provider",
    description: (
      <p className="p-fix" style={{ marginLeft: "3.5rem", marginTop: "-2rem" }}>
        {clientsLabels.provider}
      </p>
    ),
  },
];

const getDefaultState = (mode) => {
  return {
    payer: "",
    timeLimit: null,
    globalApprobe: mode === 0 || null,
    terms: false,
    alert: null,
    ...(mode === 2 && { typeRelation: null }),
  };
};

const getAvailableOptions = (mode, global) => {
  return {
    ...(mode === 1 && {
      0: {
        legend: optionsLabels["globalApprobe"],
        name: "globalApprobe",
        items: options,
      },
    }),
    ...(mode === 2 && {
      1: {
        legend: optionsLabels["typeRelation"],
        name: "typeRelation",
        items: typeRelations,
      },
    }),
    ...(global && {
      2: {
        legend: optionsLabels["payer"],
        name: "payer",
        items: clients,
      },
    }),
  };
};

const renderTermsContent = () => {
  return (
    <div style={{ width: 600, height: 500 }}>
      <p className="text-center mt-4">Terminos y condiciones</p>
    </div>
  );
};

export { getAvailableOptions, getDefaultState, renderTermsContent };
